<template>
  <div class="container">
    <LoadingSpinner v-if="waitingForResponse"></LoadingSpinner>
    <div v-else-if="!rawUserObject">
      no user found with id {{user_id}}
    </div>

    <div v-else class="card" :class="{'marked-for-deletion': rawUserObject.marked_for_deletion}">
      <div class="card-header">

        <div v-if="rawUserObject.marked_for_deletion" style="color: red; font-weight: bold;">
          MARKED FOR DELETION {{timeSinceMarkedForDeletion}} AGO
        </div>

        <button class="btn btn-sm btn-outline-secondary" type="button" @click="toggleMarkedForDeletion">
          <i class="fa fa-trash" :style="{ color: rawUserObject.marked_for_deletion? 'red' : 'lightgray' }"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" type="button" @click="toggleRole('is_legacy_user')">
          <i class="fa fa-gift" :style="{ color: rawUserObject.membership.legacy? '#b49823' : 'lightgray' }"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" type="button" @click="toggleRole('is_dev_acquaintance')">
          <i class="fa fa-handshake-o" :style="{ color: rawUserObject.roles.is_dev_acquaintance? 'black' : 'lightgray' }"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" type="button" @click="toggleRole('is_tester')">
          <i class="fa fa-heartbeat" :style="{ color: rawUserObject.roles.is_tester? 'blue' : 'lightgray' }"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" type="button" @click="toggleRole('is_admin')">
          <i class="fa fa-wrench" :style="{ color: rawUserObject.roles.is_admin? 'crimson' : 'lightgray' }"></i>
        </button>
        <button v-if="shouldDisplayDeleteUserButton" class="btn btn-sm btn-outline-danger delete-user" type="button" @click="show_user_delete_modal=true">
          delete user
        </button>


        <router-link :to="`../../profile/${user_id}`">{{rawUserObject.display_name}}<br>{{rawUserObject.auth?.email}}<br>{{rawUserObject._id}}</router-link>

      </div>

      <div class="card-body">
<!--        <pre>{{user}}</pre>-->
        <json-viewer theme="bg-body-tertiary" :value="rawUserObject" copyable boxed sort></json-viewer>
      </div>
    </div>

    <ProfilePage :user_id="user_id"></ProfilePage>

  </div>

  <GenericModal v-if="show_user_delete_modal" @modal-closed="show_user_delete_modal=false">
    <div class="text-center">
      <div>
        <p>Are you sure you want to delete this user <br><strong>{{rawUserObject.auth?.email}}</strong>?</p>
      </div>
      <button class="btn btn-sm btn-primary" type="button" data-bs-dismiss="modal">
        <i class="fa fa-user"></i> keep user
      </button>
      <button class="btn btn-sm btn-danger me-sm-2" type="button" data-bs-dismiss="modal" @click="deleteUser">
        <i class="fa fa-user-times"></i> delete user
      </button>
    </div>
  </GenericModal>
</template>


<script>
import axios from "axios";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import JsonViewer from 'vue-json-viewer'
import ProfilePage from "@/pages/ProfilePage.vue";
import GenericModal from "@/components/modal/GenericModal.vue";


export default {
  name: "AdminUserPage",
  components: {GenericModal, ProfilePage, LoadingSpinner, JsonViewer},
  props: ['user_id'],
  data() {
    return {
      waitingForResponse: false,
      rawUserObject: null,
      show_user_delete_modal: false
    }
  },
  created() {
    this.waitingForResponse = true;

    axios.get(`/api/admin/user/${this.user_id}`)
        .then((response) => {
          this.rawUserObject = response.data;
        })
        .catch((err) => {
          console.error(`error calling /api/admin/user/${this.user_id} : ${err}`)
        })
        .finally(() => {
          this.waitingForResponse = false;
        });
  },
  computed: {

    timeSinceMarkedForDeletion() {
      if ( !this.rawUserObject.marked_for_deletion ) {
        return {};
      }
      const msElapsed = Date.now() - new Date(this.rawUserObject.marked_for_deletion);

      const msPerSecond = 1000;
      const msPerMinute = 60 * msPerSecond;
      const msPerHour = 60 * msPerMinute;
      const msPerDay = 24 * msPerHour;

      const daysElapsed = Math.floor(msElapsed / msPerDay);
      const hoursElapsed = Math.floor( (msElapsed - (daysElapsed * msPerDay)) / msPerHour );
      const minutesElapsed = Math.floor( (msElapsed - ((daysElapsed * msPerDay) + (hoursElapsed * msPerHour))) / msPerMinute );
      const secondsElapsed = Math.floor( (msElapsed - ((daysElapsed * msPerDay) + (hoursElapsed * msPerHour) + (minutesElapsed * msPerMinute))) / msPerSecond );

      return {
        daysElapsed,
        hoursElapsed,
        minutesElapsed,
        secondsElapsed,
        toString() {
          let result = '';
          result += this.daysElapsed ? `${this.daysElapsed}d` : '';
          result += this.hoursElapsed ? `${this.hoursElapsed}h` : '';
          result += this.minutesElapsed ? `${this.minutesElapsed}m` : '';
          result += (msElapsed < msPerMinute) ? '<1m' : '';
          return result.trim();
        }
      };
    },

    shouldDisplayDeleteUserButton() {
      if ( !this.rawUserObject.marked_for_deletion ) {
        return false;
      }

      console.log(JSON.stringify(this.timeSinceMarkedForDeletion));
      return this.timeSinceMarkedForDeletion.daysElapsed > 0;
    }

  },
  methods: {
    dateDisplayString(_date) {
      const dateObj = ( _date instanceof Date )? _date : new Date(_date);
      return dateObj.toDateString();
    },

    toggleRole(_role) {
      const data = {};

      // todo:  This is a hack. The real solution is a different endpoint to handle legacy users,
      // todo:    as that's now considered a type of membership, not a 'role'.
      data[_role] = !( ( _role === 'is_legacy_user' )? this.rawUserObject.membership.legacy : this.rawUserObject.roles[_role] ) ;

      axios.post(`/api/admin/user/update-user-role/${this.user_id}`, data)
          .then((response) => {
            this.rawUserObject = response.data;
          })
          .catch((err) => {
            console.error(`error calling /api/admin/user/update-user-role/${this.user_id} : ${err}`)
          })
    },

    toggleMarkedForDeletion() {

      axios.post(`/api/admin/user/set-mark-for-deletion/${this.user_id}/${!(this.rawUserObject.marked_for_deletion)}`)
          .then((response) => {
            this.rawUserObject = response.data;
          })
          .catch((err) => {
            console.error(`error calling /api/admin/user/set-mark-for-deletion/${this.user_id}/${!(this.rawUserObject.marked_for_deletion)} : ${err}`)
          })
    },
    deleteUser() {
      axios.delete(`/api/admin/user/${this.user_id}`)
          .then(response => {
            console.log(response);
            this.$router.push({name: 'AdminUsersPage'});
          })
          .catch(err => {
            console.error(`error calling delete /api/admin/user/${this.user_id} : ${err}`)
          })
    }
  },
}
</script>


<style scoped>

button {
  margin-right: 5px;
  margin-left: 5px;
}

.card {
  margin-top: 50px;
  margin-bottom: 50px;

  &.marked-for-deletion {
    border-color: red;
    border-width: 4px;
    border-style: double;
  }

  .card-header {
    padding: 1em;

    .marked-for-deletion {

    }

    button {
      float: right;
      border-color: lightgray;
      width: 3em;
      margin-left: 2px;
      margin-right: 2px;

      &.delete-user {
        border-color: red;
        background-color: yellow;
        width: auto;
      }

    }

    a {
      font-family: monospace;
      text-decoration: inherit;
    }
  }

}



</style>